jQuery( document ).ready(function() {
  jQuery('.text-info-showHide').hide();
// jQuery('.inside_box').on('click',function(){
//   jQuery('.text-info-showHide').toggle();
// });
  jQuery('.inside_box').click(function() {
  //jQuery('.hideme').hide();  
  if (jQuery(this).hasClass('active')) {    
    jQuery(this).removeClass('active');
    jQuery('.text-info-showHide').slideUp();
  } else {
    jQuery('.text-info-showHide').slideUp();
    jQuery('.inside_box').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).next().filter('.text-info-showHide').slideDown();
  }
});
  
jQuery('.pro-carousel').owlCarousel({
    loop:true,
    margin:30,
    nav:true,
    dots: true,
  thumbs: false,
    responsive:{
        0:{
            items:1,
            margin:0,
        },
        600:{
          items:2,
          margin:20,
        },
        1000:{
            items:3
        }
    }
});

jQuery('.testimonial-slider').owlCarousel({
        loop:true,
        margin:30,
        nav:true,
        dots: true,
        thumbs: false,
        responsive:{
            0:{
                items:1,
                margin:0,
            },
            600:{
                items:2,
                margin:20,
            },
           1024:{
                items:3,
                margin:20,
            },
            1199:{
                items:4
            }
        }
    });
});  

jQuery(document).ready(function(){
jQuery('#multi-product').owlCarousel({
        loop: true,
        items: 1,
        slideSpeed: 2000,
        autoplay: false,
        dots: false,
        thumbs: true,
        thumbImage: true,
        thumbContainerClass: 'owl-thumbs',
        thumbItemClass: 'owl-thumb-item'
   });
 //  $('.add-to-cart-button').click(function(){
 // // event.preventDefault();
 //     var dataId = $(this).data("variant-id");
 //      var Pro_sellId = $(this).data("sell-id");
 //   // alert(dataId);
 //    addItemToCart(dataId, 1, 4, "Delivery every 4 Weeks",Pro_sellId)
 //  });
});

 // function addItemToCart(variant_id, qty, frequency, unit_type, selling_plan) {
 //    data = {
 //      "id": variant_id,
 //      "quantity": qty,
 //      "properties": {
 //      //  "shipping Frequency": frequency,
 //         "shipping Type":unit_type
 //      },
 //      "selling_plan": selling_plan
 //    }
 //    jQuery.ajax({
 //      type: 'POST',
 //      url: '/cart/add.js',
 //      data: data,
 //      dataType: 'json',
 //      success: function() { 
 //        window.location.href = '/cart'; 
 //      }
 //    });
 //    window.location = '/checkout';
 //  }
